import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import Text from "components/Text/Text"

import Spinner from "components/Spinner/Spinner"

const SelectLoadingMessage: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
    const { t } = useTranslation()
    return (
        <div className="py-3 text-center color-black">
            <Spinner />
            <Text type="h5" className="mt-2">{t('common.searching')}</Text>
        </div>
    )
}

export default SelectLoadingMessage
